module.exports = __webpack_public_path__ + "img/wms.0ebdc295.jpg";